export default __webpack_public_path__ + "static/media/experts_nav_icon.b062e648.svg";